
import axios from "axios";

/* url pointing to backend route */   

// const domainhref = window.location.origin;
// const domain = window.location.hostname;
   //  const url = `${domain==='localhost'?"http://kooovi.ilogically.com":domainhref }`; 
  

   import {apiUrl} from '../AxiosAPI' ;  

  // SignUp API post call with rest endpoint 
   export const userSignup = (signup) => axios.post(`${apiUrl}/signup`,signup);  
 
 
   // Login API post call with rest endpoint 
   export const userLogin = (login) => axios.post(`${apiUrl}/login`,login);
   export const userResetPassword = (ResetPassword) => axios.post(`${apiUrl}/resetPassWord`,ResetPassword);
   export const userVerifyOTP = (otp) => axios.post(`${apiUrl}/userVerifyOTP`,otp);
   export const userAddNewPassword = (Password) => axios.post(`${apiUrl}/addNewPassWord`,Password);
   export const createCourse = (createCourseData) => axios.post(`${apiUrl}/createCourse`,createCourseData);
    
   